import React from "react";
import { SimpleShowLayout, TextField } from "react-admin";

const Tab = (props) => {
  return (
    <SimpleShowLayout {...props}>
      <TextField source="soccer.id" />
      <TextField source="soccer.seasonWins" />
      <TextField source="soccer.seasonLosses" />
      <TextField source="soccer.seasonTies" />
      <TextField source="soccer.seasonPercentWins" />
      <TextField source="soccer.districtWins" />
      <TextField source="soccer.districtLosses" />
      <TextField source="soccer.districtTies" />
      <TextField source="soccer.homeWins" />
      <TextField source="soccer.homeLosses" />
      <TextField source="soccer.homeTies" />
      <TextField source="soccer.roadWins" />
      <TextField source="soccer.roadLosses" />
      <TextField source="soccer.roadTies" />
      <TextField source="soccer.streak" />
      <TextField source="soccer.differential" />

      <TextField source="soccer.teamGameCount" />
      <TextField source="soccer.totalGoals" />
      <TextField source="soccer.goalsAgainst" />
      <TextField source="soccer.goalsPerGame" />
      <TextField source="soccer.goalsAgainstPerGame" />
    </SimpleShowLayout>
  );
};

export default Tab;
